import React from 'react';
export default (function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
});


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/table/FilterDropdownMenuWrapper.js
// module id = 761
// module chunks = 0